<template>
    <div class="vuetify-wrapper d-inline-flex align-center">
        <v-icon
            v-for="(_, index) in Array(5)"
            :key="index"
            color="rgba(246, 177, 0)"
        >
            {{ renderStarIcon(index) }}
        </v-icon>
        <h5 class="mx-1">({{ rating }})</h5>
    </div>
</template>

<script>
export default {
    props: {
        rating: Number
    },
    methods: {
        renderStarIcon(index) {
            const rating = +this.rating;
            if (!Number.isInteger(rating) && Math.ceil(rating) === index + 1) {
                return 'mdi-star-half-full'; // for float numbers
            } else if (index + 1 <= rating) {
                return 'mdi-star';
            } else {
                return 'mdi-star-outline';
            }
        },
    }
}
</script>